import styles from "./alert-modal.module.css";
import { Modal } from "BEDROCK/shared-components/modal";
import { CTAButton } from "./cta-button";
import { filterClasses } from "PosterEditor/utils/filter-classes";

type CTAArrangement = "HORIZONTAL" | "VERTICAL";

interface AlertModalProps {
  title: string;
  message: string;
  isShowing: boolean;
  proceedCTA?: string;
  dismissCTA?: string;
  ctaArrangement?: CTAArrangement; // Default is horizontal
  onProceed?: () => void;
  onDismiss: () => void;
  className?: string;
}

export const AlertModal = ({
  title,
  message,
  isShowing,
  proceedCTA,
  dismissCTA = "OK",
  ctaArrangement = "HORIZONTAL",
  onProceed,
  onDismiss,
  className,
}: AlertModalProps) => {
  return (
    <Modal isOpen={isShowing} showCloseButton={false} onClose={onDismiss}>
      <div className={filterClasses(styles.container, className)}>
        <h1>{title}</h1>
        <p>{message}</p>
        <div
          className={filterClasses(
            ctaArrangement === "HORIZONTAL" ? styles.ctaRow : styles.ctaCol
          )}
        >
          <CTAButton
            className={filterClasses(
              ctaArrangement === "VERTICAL" ? styles.cta : ""
            )}
            variant="SECONDARY"
            onClick={onDismiss}
          >
            {dismissCTA ?? "OK"}
          </CTAButton>
          {onProceed && (
            <CTAButton
              className={filterClasses(
                ctaArrangement === "VERTICAL" ? styles.cta : ""
              )}
              variant="PRIMARY"
              onClick={onProceed}
            >
              {proceedCTA ?? "PROCEED"}
            </CTAButton>
          )}
        </div>
      </div>
    </Modal>
  );
};
